const elementsListInfo ={
    "heading1" : {
        title : "Heading 1",
        elements : [
            {
                tagName : "h1",
                classList : "learnworlds-heading-large learnworlds-weight-bold ellipsis",
                label : "Large heading 1",
                selector : "heading1Large"
            },
            {
                tagName : "h1",
                classList : "learnworlds-heading-normal learnworlds-weight-bold ellipsis",
                label : "Normal heading 1",
                selector : "heading1Normal"
            },
            {
                tagName : "h1",
                classList : "learnworlds-heading-small learnworlds-weight-bold ellipsis",
                label : "Small heading 1",
                selector : "heading1Small"
            }
        ]
    },
    "heading2" : {
        title : "Heading 2",
        elements : [
            {
                tagName : "h2",
                classList : "learnworlds-subheading-large ellipsis",
                label : "Large heading 2",
                selector : "heading2Large"
            },
            {
                tagName : "h2",
                classList : "learnworlds-subheading-normal ellipsis",
                label : "Normal heading 2",
                selector : "heading2Normal"
            },
            {
                tagName : "h2",
                classList : "learnworlds-subheading-small ellipsis",
                label : "Small heading 2",
                selector : "heading2Small"
            }
        ]
    },
    "heading3" : {
        title : "Heading 3",
        elements : [
            {
                tagName : "h3",
                classList : "learnworlds-heading3-large ellipsis",
                label : "Large heading 3",
                selector : "heading3Large"
            },
            {
                tagName : "h3",
                classList : "learnworlds-heading3-normal ellipsis",
                label : "Normal heading 3",
                selector : "heading3Normal"
            },
            {
                tagName : "h3",
                classList : "learnworlds-heading3-small ellipsis",
                label : "Small heading 3",
                selector : "heading3Small"
            }
        ]
    },
    "text" : {
        title : "Text",
        elements : [
            {
                tagName : "p",
                classList : "learnworlds-main-text-huge ellipsis",
                label : "Huge text",
                selector : "textHuge"
            },
            {
                tagName : "p",
                classList : "learnworlds-main-text-very-large ellipsis",
                label : "Very large text",
                selector : "textVeryLarge"
            },
            {
                tagName : "p",
                classList : "learnworlds-main-text-large ellipsis",
                label : "Large text",
                selector : "textLarge"
            },
            {
                tagName : "p",
                classList : "learnworlds-main-text-normal ellipsis",
                label : "Normal text",
                selector : "textNormal"
            },
            {
                tagName : "p",
                classList : "learnworlds-main-text-small ellipsis",
                label : "Small text",
                selector : "textSmall"
            },
            {
                tagName : "p",
                classList : "learnworlds-main-text-very-small ellipsis",
                label : "Very small text",
                selector : "textVerySmall"
            },
            {
                tagName : "p",
                classList : "learnworlds-main-text-tiny ellipsis",
                label : "Tiny text",
                selector : "textTiny"
            },
            {
                tagName : "p",
                classList : "learnworlds-quote-text ellipsis",
                label : "Quote text",
                selector : "quote"
            },
            {
                tagName : "p",
                classList : "learnworlds-overline-text learnworlds-letter-casing-uppercase ellipsis",
                label : "Overline text",
                selector : "overline"
            },
        ]
    },
    "button" : {
        title : "Buttons",
        elements : [
            {
                tagName : "button",
                label : "Button",
                groupedElements : [
                    {
                        classList : "learnworlds-button learnworlds-button-normal learnworlds-button-solid-accent1",
                        selector : "solidNormalButtonAccent1"
                    },
                    {
                        classList : "learnworlds-button learnworlds-button-normal learnworlds-button-solid-accent2",
                        selector : "solidNormalButtonAccent2"
                    },
                    {
                        classList : "learnworlds-button learnworlds-button-normal learnworlds-button-outline-accent1",
                        selector : "outlineNormalButtonAccent1"
                    },
                    {
                        classList : "learnworlds-button learnworlds-button-normal learnworlds-button-outline-accent2",
                        selector : "outlineNormalButtonAccent2"
                    },
                    {
                        classList : "learnworlds-button learnworlds-button-normal lw-circle-icon-button learnworlds-button-solid-accent1",
                        selector : "solidCircleIconButtonAccent1"
                    },
                    {
                        classList : "learnworlds-button learnworlds-button-normal lw-circle-icon-button learnworlds-button-outline-accent1",
                        selector : "outlineCircleIconButtonAccent1"
                    }
                ]
            }
        ]
    },
    "screen" : {
        title : "Screen",
        elements : [
            {
                tagName : "image",
                classList : "learnworlds-frame",
                selector : "normalImage"
            },
            {
                tagName : "image",
                classList : "learnworlds-laptop black",
                selector : "laptopImage"
            }
        ]
    },
    "column" : {
        title : "Columns",
        elements : [
            {
                tagName : "img",
                selector : "column1",
                thumbnail : imagePath + "/author/images/pagesbuilder/column1.jpg"
            },
            {
                tagName : "img",
                selector : "column2",
                thumbnail : imagePath + "/author/images/pagesbuilder/column2.jpg"
            },
            {
                tagName : "img",
                selector : "column3",
                thumbnail : imagePath + "/author/images/pagesbuilder/column3.jpg"
            },
            {
                tagName : "img",
                selector : "column4",
                thumbnail : imagePath + "/author/images/pagesbuilder/column3.jpg"
            }
        ]
    },
    "list" : {
        title : "Lists",
        elements : [
            {
                tagName : "img",
                selector : "list1",
                thumbnail : imagePath + "/author/images/pagesbuilder/list1.jpg"
            },
            {
                tagName : "img",
                selector : "list2",
                thumbnail : imagePath + "/author/images/pagesbuilder/list2.jpg"
            },
            {
                tagName : "img",
                selector : "list3",
                thumbnail : imagePath + "/author/images/pagesbuilder/list3.jpg"
            }
        ]
    },
    "layout" : {
        title : "Layout elements",
        elements : [
            {
                tagName : "img",
                selector : "vdistance",
                thumbnail : imagePath + "/author/images/pagesbuilder/vdistance1.jpg"
            },
            {
                tagName : "img",
                selector : "hline1",
                thumbnail : imagePath + "/author/images/pagesbuilder/hline1.jpg"
            }
        ]
    },
    "subscribe" : {
        title : "Subscribe",
        elements : [
            {
                tagName : "img",
                selector : "subscribe1",
                thumbnail : imagePath + "/author/images/pagesbuilder/subscribe.jpg"
            }
        ]
    },
    "Blog_posts" : {
        title : "Blog posts",
        elements : [
            {
                tagName : "img",
                selector : "blogPosts1",
                thumbnail : imagePath + "/author/images/pagesbuilder/blogposts.jpg"
            }
        ]
    },
    "Apps" : {
        title : "Apps",
        elements : [
            {
                label: "Media",
                component: 'media',
                thumbnail : imagePath + "/author/images/pagesbuilder/list3.jpg"
            },
            {
                label: "CoursesWrapper",
                component: 'courseswrapper',
                thumbnail : imagePath + "/author/images/pagesbuilder/list3.jpg"
            }
        ]
    }
}

export { elementsListInfo }